import {
  GET_INSIGHT_1,
  GET_SALES_DATA,
  GET_ORDERS_DATA,
  GET_POPULAR_TIME,
  SET_REPORT_STATUS,
  GET_ACCOUNT_STATUS,
  RESET_DASHBOARD_STATE,
  SET_GENERAL_DASH_STATS,
  SET_UPCOMING_CELEBRATIONS,
  GET_POPULAR_ITEMS_AND_CATEGORIES,
  SET_ACTIVE_CUSTOMER_LIFECYCLE_TEMPLATES,
} from "../types";

const initialState = {
  status: {},
  hlAndFreq: {},
  sales: [],
  orders: [],
  time: {},
  reportStatus: {},
  popularItemsAndCate: {},
  upcomingCelebrations: {},
  generalStats: {},
  customerLifecycle: {
    activeCarousel: null,
  },
};

const store = (state = initialState, action) => {
  switch (action.type) {
    case GET_ACCOUNT_STATUS:
      return {
        ...state,
        status: action.payload,
      };
    case GET_INSIGHT_1:
      return {
        ...state,
        hlAndFreq: action.payload,
      };
    case GET_SALES_DATA:
      return {
        ...state,
        sales: action.payload,
      };
    case GET_ORDERS_DATA:
      return {
        ...state,
        orders: action.payload,
      };
    case GET_POPULAR_TIME:
      return {
        ...state,
        time: action.payload,
      };
    case GET_POPULAR_ITEMS_AND_CATEGORIES:
      return {
        ...state,
        popularItemsAndCate: action.payload,
      };
    case SET_UPCOMING_CELEBRATIONS:
      return {
        ...state,
        upcomingCelebrations: action.payload,
      };
    case SET_REPORT_STATUS:
      return {
        ...state,
        reportStatus: action.payload,
      };
    case SET_GENERAL_DASH_STATS:
      return {
        ...state,
        generalStats: action.payload,
      };
    case SET_ACTIVE_CUSTOMER_LIFECYCLE_TEMPLATES:
      return {
        ...state,
        customerLifecycle: { activeCarousel: action.payload },
      };
    case RESET_DASHBOARD_STATE:
      return initialState;
    default:
      return state;
  }
};

export default store;
